import { render, staticRenderFns } from "./ConfirmAddressModal.vue?vue&type=template&id=07e591a9&scoped=true&"
import script from "./ConfirmAddressModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAddressModal.vue?vue&type=style&index=0&id=07e591a9&lang=scss&scoped=true&"
import style1 from "./ConfirmAddressModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e591a9",
  null
  
)

export default component.exports